module.exports = __webpack_public_path__ + "img/img001.a6823491.png";